import Events from "../classes/Events";

let stack = false;
export default class AppChannel extends Events {
    trigger() {
        let args = [].slice.call(arguments);

        if ( !stack ) {
            return super.trigger(...arguments);
        }

        stack.push({
            context: this,
            args
        });

        return this;
    }

    static startCatching(_stack) {
        stack = _stack;
    }

    static fireCatched(_stack) {
        stack = false;

        _stack.forEach((elem) => {
            let context = elem.context;
            let args = elem.args;

            context.trigger.apply(context, args);
        });
    }
}
